import config from "src/config";
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, postData, deleteData } from 'src/utils/axios/serverHelper';
import { MST4060_R01HeaderDto, MST4060_R01Dto } from './Dto_MST4060_R01';
import { MST4060_R01Filter } from "./Store_MST4060_R01";

const baseUrl = `${config.apiUrl}/MST4060_R01`;

/**
 * 헤더 목록 조회 (예비품 목록)
 */
export const getMST4060_R01HeaderList = async (
	option: string,
	params: Partial<MST4060_R01Filter>,
	listLength: number = 0,
	refetchListLength: number = 0
) => {
	const url = option === 'search'
		? `${baseUrl}/header/search`
		: `${baseUrl}/header`;

	return await getData<ResponseDto<MST4060_R01HeaderDto[]>>(url, {
		params: { ...params, listLength, refetchListLength }
	});
}

/**
 * 헤더 전체 개수 조회
 */
export const getMST4060_R01HeaderAllCount = async (params: Partial<MST4060_R01Filter>) => {
	const url = `${baseUrl}/header/allCount`;
	return await getData<ResponseDto<number>>(url, { params: { ...params } });
}

/**
 * 디테일 목록 조회 (입출고 내역)
 */
export const getMST4060_R01DetailList = async (
	option: string,
	params: Partial<MST4060_R01Filter>,
	listLength: number = 0,
	refetchListLength: number = 0
) => {
	const url = option === 'search'
		? `${baseUrl}/detail/search`
		: `${baseUrl}/detail`;

	return await getData<ResponseDto<MST4060_R01Dto>>(url, {
		params: { ...params, listLength, refetchListLength }
	});
}

/**
 * 디테일 전체 개수 조회
 */
export const getMST4060_R01DetailAllCount = async (params: Partial<MST4060_R01Filter>) => {
	const url = `${baseUrl}/detail/allCount`;
	return await getData<ResponseDto<number>>(url, { params: { ...params } });
}

/**
 * 헤더 + 활성 디테일 전체 목록 통합 저장 (단일 트랜잭션, 실패 시 전체 롤백)
 * 서버가 요청 상세 목록과 DB 목록을 비교해 등록·수정·삭제를 처리
 */
export const saveMST4060_R01 = async (data: MST4060_R01Dto) => {
	const url = `${baseUrl}/save`;
	return await postData<MST4060_R01Dto, ResponseDto<MST4060_R01Dto>>(url, data);
}

/**
 * 예비품과 해당 입출고 내역 삭제
 */
export const deleteMST4060_R01Header = async (equipmentCd: string) => {
	const url = `${baseUrl}/header/${equipmentCd}`;
	return await deleteData<ResponseDto<any>>(url);
}

/**
 * 특정 예비품의 엑셀 다운로드 (헤더 + 입출고 내역)
 */
export const downloadExcel_MST4060_R01 = async (equipmentCd: string) => {
	const url = `${baseUrl}/header/${equipmentCd}/excel`;
	return await getData<ResponseDto<string>>(url);
}
